import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import EscapeDetail from "@/pages/EscapeDetail";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import ThemeLanding from "@/pages/ThemeLanding";
import Guide from "@/pages/Guide";
import InfoPage from "@/pages/InfoPage";
import FindMyRetreat from "@/pages/FindMyRetreat";
import Guides from "@/pages/Guides";
import SeoDashboard from "@/pages/SeoDashboard";

const THEME_SLUGS = [
  "yoga-retreats",
  "wellness-retreats",
  "yacht-retreats",
  "yoga-sailing-retreats",
  "retreats-for-beginners",
];

const INFO_SLUGS = ["about", "contact", "privacy-policy", "terms", "affiliate-disclosure", "how-it-works"];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/find-my-retreat" element={<FindMyRetreat />} />
          <Route path="/escape/:id" element={<EscapeDetail />} />
          {THEME_SLUGS.map((slug) => (
            <Route key={slug} path={`/${slug}`} element={<ThemeLanding slug={slug} />} />
          ))}
          {INFO_SLUGS.map((slug) => (
            <Route key={slug} path={`/${slug}`} element={<InfoPage slug={slug} />} />
          ))}
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/:slug" element={<Guide />} />
          <Route path="/admin/seo" element={<SeoDashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
